import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { Grid, designTokens } from '@itandi/itandi-bb-ui';
import { StatusCard } from './StatusCard';

export type StatusCardItems = DeepReadonly<
  {
    count: number;
    href: string;
    label: string;
    variant: 'default' | 'past' | 'today';
  }[]
>;

type Props = {
  statusCards: StatusCardItems;
};

/**
 * ダッシュボード画面で状況によって分類されたステータスカード一覧を表示するコンポーネント
 *
 * @for client, vendor
 */

export const StatusCardList: React.FC<Props> = ({ statusCards }: Props) => (
  <Grid
    gap={designTokens['spacing/m']}
    gridTemplateColumns={`repeat(${statusCards.length}, 1fr)`}
  >
    {statusCards.map((statusCard) => (
      <StatusCard
        key={statusCard.label}
        count={statusCard.count}
        href={statusCard.href}
        label={statusCard.label}
        variant={statusCard.variant}
      />
    ))}
  </Grid>
);
